import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { AddSchoolIncidentComponent } from "./add-school-incident/add-school-incident.component";
import { EditSchoolIncidentComponent } from "./edit-school-incident/edit-school-incident.component";
import { DataService_SchoolIncidentSetup } from "./shared/data.service";
import * as moment from "moment";

@Component({
	selector: "app-school-incident-setup",
	templateUrl: "./school-incident-setup.component.html",
	styleUrls: ["./school-incident-setup.component.css"],
})
export class SchoolIncidentSetupComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private userService: UserService,
		private SchoolIncidentSetupService: DataService_SchoolIncidentSetup,
		private dialogService: DialogService,
		private schoolService: SchoolService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		// this.loadSchoolist();
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	subscription: any;

	SchoolID: any;
	lstSchool: any = [];

	StartDT: Date = new Date();
	EndDT: Date = new Date();

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedSchoolIncident: any;
	lstSchoolIncident: any = [];

	//Filter lists
	lstSchoolIncidentTypeDesc: any = [];
	lstActiveDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "IncidentDTDesc", header: "Date/Time" },
		{ field: "SchoolIncidentTypeDesc", header: "Incident Type" },
		{ field: "Comment", header: "Comment" },
		{ field: "AdminName", header: "Created By" },
		// { field: 'ActiveDesc', header: 'Active' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////
	loadSchoolist() {
		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchool = response;
				this.SchoolID = this.lstSchool[0].SchoolID;

				this.loadSchoolIncident();
			},
			(error) => {}
		);
	}

	loadSchoolIncident() {
		this.loading = true;

		//Format dates
		var fsDate = moment(this.StartDT).format("MM/DD/YYYY");
		var feDate = moment(new Date(moment(this.EndDT).format("MM/DD/YYYY") + " 23:59:59")).format("MM/DD/YYYY HH:mm:ss"); //Include all of the end date

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1 || String(feDate).toLowerCase().indexOf("invalid") != -1) {
			this.loading = false;
			return;
		}

		var result = this.SchoolIncidentSetupService.LoadSchoolIncident(this.SchoolID, fsDate, feDate);
		result.subscribe(
			(response) => {
				this.lstSchoolIncident = response;

				for (var i = 0; i < this.lstSchoolIncident.length; i++) {
					var next = this.lstSchoolIncident[i];

					if (next.FirstName != "") {
						next.AdminName = next.FirstName;
						if (next.LastName != "") {
							next.AdminName += " " + next.LastName;
						}
					} else if (next.LastName != "") {
						next.AdminName = next.LastName;
					} else {
						next.AdminName = "";
					}

					next.ActiveDesc = next.Active == 1 ? "Yes" : "No";
					next.IncidentDTDesc = moment(new Date(next.IncidentDT)).format("MM/DD/YYYY h:mm a");
				}

				//Load Data Filter Lists
				this.lstSchoolIncidentTypeDesc = Array.from(new Set(this.lstSchoolIncident.map((item: any) => item.SchoolIncidentTypeDesc))).sort();
				this.lstActiveDesc = Array.from(new Set(this.lstSchoolIncident.map((item: any) => item.ActiveDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadSchoolIncident();
		this.onRowUnselect(null);
	}

	//Custom Button Methods
	onAddIncident() {
		this.errorMessage = "";

		var ref = this.dialogService.open(AddSchoolIncidentComponent, {
			header: "Add Incident",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				user: this.user,
				SchoolID: this.SchoolID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadSchoolIncident();
			}
		});
	}

	onEditIncident() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedSchoolIncident == undefined) {
			this.errorMessage = "Select an incident to edit";
			return;
		}

		var ref = this.dialogService.open(EditSchoolIncidentComponent, {
			header: "Edit Incident",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SchoolID: this.SchoolID,
				SelectedIncident: this.SelectedSchoolIncident,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadSchoolIncident();
			}
		});
	}

	onDeleteIncident() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedSchoolIncident == undefined) {
			this.errorMessage = "Select an incident to delete";
			return;
		}

		this.confirmationService.confirm({
			key: "main",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "Do you want to delete the selected school incident?",
			header: "Delete School Incident",
			icon: "fa",
			accept: () => {
				this.FinishDelete();
			},
			reject: () => {},
		});
	}
	FinishDelete() {
		//Call SP
		var result = this.SchoolIncidentSetupService.SchoolIncidentDelete(this.SelectedSchoolIncident.SchoolIncidentID);
		result.subscribe(
			(response) => {
				if (response) {
					this.loadSchoolIncident();
					this.onRowUnselect(null);
				} else {
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not delete the School Incident",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onStartDateChange(val) {
		this.errorMessage = "";

		this.StartDT = val;

		this.loadSchoolIncident();
		this.onRowUnselect(null);
	}

	onEndDateChange(val) {
		this.errorMessage = "";

		this.EndDT = val;

		this.loadSchoolIncident();
		this.onRowUnselect(null);
	}

	onSchoolChange(val) {
		this.errorMessage = "";

		this.SchoolID = val;

		this.loadSchoolIncident();

		this.onRowUnselect(null);
	}
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";

		this.SelectedSchoolIncident = val.data;
	}
	onRowUnselect(val) {
		this.errorMessage = "";

		this.SelectedSchoolIncident = null;
	}
	onRowDblClick(SchoolIncident) {
		this.errorMessage = "";

		this.SelectedSchoolIncident = SchoolIncident;
		this.onEditIncident();
	}
	////////////////////////////////////////////
}
